import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Switch, Select, Table } from "antd";
import { ArrowCircleLeft } from "iconsax-react";

import { GlobalContext } from "../../../app/providers/GlobalState";

import { useAxios } from "../../../shared/hooks/useAxios";
import { useNotification } from "../../../shared/hooks/useNotification";

import Header from "../../../User/Header";
import TableDesktop from "./components/TableDesktopGrupos";
import TableMobile from "./components/TableMobileGrupos";
import DrawerGrupo from "./components/DrawerGrupo";
import DrawerHabilidade from "./components/DrawerHabilidade";

const { Option } = Select;

const HabilidadesPage = () => {
    const [ativo, setAtivo] = useState(true);
    const [grupos, setGrupos] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10
    });
    const [grupoId, setGrupoId] = useState(0);
    const [drawerGrupoVisible, setDrawerGrupoVisible] = useState(false);
    const [habilidadeId, setHabilidadeId] = useState(0);
    const [drawerHabilidadeVisible, setDrawerHabilidadeVisible] = useState(false);

    const context = useContext(GlobalContext);

    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const handleChangeSwitch = ativo => {
        setAtivo(ativo);
    };

    const handleChange = pagination => {
        setPagination({ ...pagination, current: pagination.current });
    };

    const handleExpand = (expanded, grupo) => {
        if (expanded) carregarHabilidadesPorGrupo(grupo.id);
    };

    const carregarGrupos = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/habilidades/carregar-grupos",
            params: {
                ativo
            }
        });

        if (!error) {
            setGrupos(data);
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const carregarHabilidadesPorGrupo = async grupoId => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/habilidades/carregar-habilidades",
            params: {
                grupoId,
                ativo
            }
        });

        if (!error) {
            const gruposAtualizados = grupos.map(grupo => {
                if (grupo.id === grupoId)
                    return {
                        ...grupo,
                        habilidades: data.habilidades,
                        subgrupos: data.subgrupos
                    };
                else return grupo;
            });

            setGrupos(gruposAtualizados);
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const abrirDrawerGerirGrupo = id => {
        setGrupoId(id);
        setDrawerGrupoVisible(true);
    };

    const atualizarListagemDeGrupos = () => {
        carregarGrupos();
        setDrawerGrupoVisible(false);
    };

    const abrirDrawerGerirHabilidade = (grupoId, habilidadeId) => {
        setGrupoId(grupoId);
        setHabilidadeId(habilidadeId);
        setDrawerHabilidadeVisible(true);
    };

    const atualizarListagemDeHabilidades = grupoId => {
        carregarHabilidadesPorGrupo(grupoId);
        setDrawerHabilidadeVisible(false);
    };

    useEffect(() => {
        carregarGrupos();
    }, [pagination, ativo]);

    return (
        <>
            <Header titulo="Habilidades" />
            <div className="container container-body">
                <div className="bloco-v2 bloco-cursos">
                    <div className="bloco-tabela">
                        <div className="filtros filtros-desktop" style={{ display: "block" }}>
                            <div className="bloco-filtros-1" style={{ gap: 10 }}>
                                <div>
                                    <button
                                        className="botao-principal botao-principal-redondo"
                                        title="Adicionar"
                                        onClick={() => abrirDrawerGerirGrupo(0)}
                                        disabled={!ativo}
                                    >
                                        +
                                    </button>
                                </div>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Switch
                                        checkedChildren="Ativos"
                                        unCheckedChildren="Inativos"
                                        defaultChecked
                                        checked={ativo}
                                        onChange={handleChangeSwitch}
                                    />

                                    <Link
                                        className="botao-voltar2"
                                        to="/utilizador"
                                        onClick={() => {
                                            context.atualizarState({
                                                mostrarOptConfiguracoes: true
                                            });
                                        }}
                                    >
                                        <ArrowCircleLeft size="32" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="filtros filtros-mobile">
                            <div className="bloco-esquerda bloco-esquerda-cursos">
                                <div className="controlos" style={{ display: "flex", justifyContent: "space-between", marginBottom: 0 }}>
                                    <div>
                                        <button
                                            className="botao-principal botao-principal-redondo"
                                            title="Adicionar"
                                            onClick={() => abrirDrawerGerirGrupo(0)}
                                            disabled={!ativo}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div className="filtros" style={{ paddingTop: 8 }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Switch
                                                checkedChildren="Ativos"
                                                unCheckedChildren="Inativos"
                                                defaultChecked
                                                checked={ativo}
                                                onChange={handleChangeSwitch}
                                            />

                                            <Link
                                                className="botao-voltar2"
                                                to="/utilizador"
                                                onClick={() => {
                                                    context.atualizarState({
                                                        mostrarOptConfiguracoes: true
                                                    });
                                                }}
                                            >
                                                <ArrowCircleLeft size="32" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <TableDesktop
                            className="curso-disciplinas-desktop"
                            ativo={ativo}
                            grupos={grupos}
                            pagination={pagination}
                            loading={loading}
                            handleChange={handleChange}
                            handleExpand={handleExpand}
                            handleRowClickGrupo={grupoId => abrirDrawerGerirGrupo(grupoId)}
                            handleRowClickHabilidade={(grupoId, habilidadeId) => abrirDrawerGerirHabilidade(grupoId, habilidadeId)}
                            abrirDrawerGerirHabilidade={abrirDrawerGerirHabilidade}
                            atualizarListagemDeGrupos={atualizarListagemDeGrupos}
                            atualizarListagemDeHabilidades={atualizarListagemDeHabilidades}
                        />
                        <TableDesktop
                            className="curso-disciplinas-mobile"
                            ativo={ativo}
                            grupos={grupos}
                            pagination={pagination}
                            loading={loading}
                            handleChange={handleChange}
                            handleExpand={handleExpand}
                            handleRowClickGrupo={grupoId => abrirDrawerGerirGrupo(grupoId)}
                            handleRowClickHabilidade={(grupoId, habilidadeId) => abrirDrawerGerirHabilidade(grupoId, habilidadeId)}
                            abrirDrawerGerirHabilidade={abrirDrawerGerirHabilidade}
                            atualizarListagemDeGrupos={atualizarListagemDeGrupos}
                            atualizarListagemDeHabilidades={atualizarListagemDeHabilidades}
                        />
                    </div>
                </div>
            </div>
            <DrawerGrupo
                grupoId={grupoId}
                ativo={ativo}
                visible={drawerGrupoVisible}
                onClose={() => setDrawerGrupoVisible(false)}
                atualizarListagem={atualizarListagemDeGrupos}
            />
            <DrawerHabilidade
                grupoId={grupoId}
                habilidadeId={habilidadeId}
                ativo={ativo}
                visible={drawerHabilidadeVisible}
                onClose={() => setDrawerHabilidadeVisible(false)}
                atualizarListagem={atualizarListagemDeHabilidades}
            />
        </>
    );
};

export default HabilidadesPage;
